import { render } from "./RecoverPinPage.vue?vue&type=template&id=38b9a101&ts=true"
import script from "./RecoverPinPage.vue?vue&type=script&lang=ts"
export * from "./RecoverPinPage.vue?vue&type=script&lang=ts"

import "./RecoverPinPage.vue?vue&type=style&index=0&id=38b9a101&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__